import url from './url';

function handlePostLogin(payload) {

    return fetch(`${url}/login`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'post',
        body: JSON.stringify(payload)
    }).then(res => res.json());

}

async function handleResetPassword(payload) {

    return await fetch(`${url}/password/create`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'post',
        body: JSON.stringify(payload)
    }).then(res => res.json());

}

async function handleCreateAccount(payload) {

    return await fetch(`${url}/register`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'post',
        body: JSON.stringify(payload)
    }).then(res => res.json());
    
}

function handleLogout(token) {

    let data = fetch(`${url}/logout`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'post'
    }).then(res => res.json());

    return data;

}

export { handlePostLogin, handleLogout, handleCreateAccount, handleResetPassword }